"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = theme => ({
  tableCell: {
    fontSize: '1em',
    color: theme.palette.primary.main
  },
  tableSortLabel: {
    color: 'inherit'
  }
});
class EnhancedTableHead extends _react.Component {
  createSortHandler = (e, column) => {
    this.props.onRequestSort(e, column);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let cells = props.columns.map(function (column, i) {
      let sort_label;
      if (column.sortable !== false) {
        let styles = {};
        if (column.center === true) {
          styles['paddingLeft'] = '16px';
        }
        sort_label = /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
          title: "Trier",
          placement: column.numeric ? 'bottom-end' : 'bottom-start',
          enterDelay: 320
        }, /*#__PURE__*/_react.default.createElement(_TableSortLabel.default, {
          style: styles,
          className: props.classes.tableSortLabel,
          active: props.order_by === column.id,
          direction: props.order,
          onClick: function (e) {
            component.createSortHandler(e, column);
          }
        }, column.label));
      } else {
        sort_label = column.label;
      }
      let styles;
      if (column.center === true) {
        styles = {
          textAlign: 'center'
        };
      }
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: (props.classes.tableCell || '') + ' table-cell',
        key: i,
        align: column.align || (column.numeric ? 'right' : 'left'),
        sortDirection: props.order_by === column.id ? props.order : false,
        style: styles
      }, sort_label);
    });
    let selection;
    if (props.onSelectAllClick) {
      selection = /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        padding: "checkbox",
        style: {
          textAlign: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        onChange: props.onSelectAllClick,
        indeterminate: props.selected_count > 0 && props.selected_count < props.row_count,
        checked: props.selected_count > 0 && props.selected_count === props.row_count
      }));
    }
    let output = /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, selection, cells));
    return output;
  }
}
var _default = exports.default = (0, _styles.withStyles)(styles)(EnhancedTableHead);
